import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import {
  BemsGraph,
  FemsGraph,
  ifacSecurityURL,
  MasterGraph,
} from "../../utility/apiURLS";
import { staff, validations } from "../../utility/constants/errors/messages";
import { dialogContent } from "../../utility/message";
import {
  getAuthToken,
  getcompanyId,
  getFacilityId,
  getuserId,
} from "../../utility/tokenUtility";
import utilities from "../../utility/utilities";
import ActionButtons from "../commoncomponents/ActionButtons";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomMultiSelect from "../commoncomponents/CustomMultiSelect";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import PageTitle from "../commoncomponents/PageTitle";
import SectionTitle from "../commoncomponents/SectionTitle";
import FileHandling from "./FileHandling";
import imageCompression from "browser-image-compression";
import PageLoader from "../commoncomponents/PageLoader";

function StaffRegister() {
  const facilityId = getFacilityId();
  const companyId = getcompanyId();
  const token = getAuthToken("id_token");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const currentDate = utilities.getCurrentDateFormatted("DD-MM-YYYY");
  const [isLoading, setIsLoading] = useState(false)
  const [clearField, setClearField] = useState(false);
  const [isNavigate, setIsNavigate] = useState(true)
  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];

  const profileEditStyle = {
    width: "27px",
    height: "27px",
    borderRadius: "50%",
    border: " 2px solid white",
    position: "absolute",
    top: "57px",
    left: "80px",
    minWidth: "0px",
  };
  const navigate = useNavigate();
  const location = useLocation();
  const childRef = useRef(null);
  const [id, setId] = useState("");
  const [empUserId, setEmpUserId] = useState("")
  const [fRowData, setFRowData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [designation, setDesignation] = useState("");
  const [workGroups, setWorkGroups] = useState([]);
  const [selectedWorkGroups, setSelectedWorkGroups] = useState([]);
  const [effectiveFrom, setEffectiveFrom] = useState("");
  const [skillLevel, setSkillLevel] = useState("");
  const [qualification, setQualification] = useState("");
  const [hourlyRate, setHourlyRate] = useState("");
  const [responseWorkgroupArray, setResponseWorkgroupArray] = useState([]);
  const [baseLocationCode, setBaseLocationCode] = useState("");
  const [baseLocationDesc, setBaseLocationDesc] = useState("");
  const [roleName, setRoleName] = useState('');
  const [roleDescription, setRoleDescription] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [isAddNew, setIsAddNew] = useState(false);
  const [openValidationDialog, setOpenValidationDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDialog, setContentDialog] = useState("");
  const [enableSubmit, setEnableSubmit] = useState(true);

  const [isChanged, setIsChanged] = useState(false);
  const [employeeType, setEmployeeType] = useState("");
  const [employeeTypeOptions, setEmployeeTypeOptions] = useState([]);
  const [skillLevelOptions, setSkillLevelOptions] = useState([]);
  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [workGroupOptions, setWorkGroupOptions] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [imagepath, setImagePath] = useState("");
  const [employeeOptions, setEmployeeOptions] = useState([])
  const [errors, setErrors] = useState({});
  const [errorMessages, setErrorMessages] = useState({});

  useEffect(() => {
    if (isEdit) fetchData(id, empUserId);
    else {
      fetchOptions();
      fetchEmployeeOptions()
    }
    if (!isEdit) setEffectiveFrom(currentDate);
  }, [isEdit, id]);

  useEffect(() => {
    if (location.state) {
      const { id, isEditMode, userId } = location.state;
      setId(id);
      setIsEdit(isEditMode);
      setEmpUserId(userId)
    }
  }, [location.state]);

  const fetchData = async (id, userId) => {
    try {

      const employeeResponse = await axios.get(
        `${MasterGraph}/api/GraphMasemployeedetails/GetMasemployeedetailsListByFacilityId/${id}/${facilityId}/${userId}/${token}`,
        config
      );
      const emp = employeeResponse.data[0]
      const services = emp?.service === ""
        ? []
        : emp?.service?.split(", ")
      fetchOptions(services);

      setEmployeeName(emp?.empName);
      setEmployeeId({
        label: emp?.empCode,
        ...emp
      }
      )
      setDesignation(emp?.designation);
      setEffectiveFrom(
        utilities.formatDate({
          dateString: emp?.effectiveFrom,
          format: "dd/mm/yyyy",
          dbdate: true,
        })
      );
      setHourlyRate(emp?.hourlyRate);
      setBaseLocationCode(emp?.locationCode);
      setBaseLocationDesc(emp?.locationDesc)
      setRoleName(emp?.roleCode)
      setRoleDescription(emp?.roleDesc)
      setSelectedServices(
        emp?.service === ""
          ? []
          : emp?.service?.split(", ")
      );
      setEmployeeType(emp?.staffTypeId);
      setSkillLevel(emp?.skillLevelId);
      setQualification(emp?.qualificationId);
      setSelectedWorkGroups(emp?.workGroup?.split(", "));
      setPreviewUrl(emp?.imagepath);
      setImagePath(emp?.imagepath);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (isEdit) {
      if (employeeTypeOptions?.length > 0) {
        if (!employeeType?.id) {
          setEmployeeType((prevStatus) =>
            employeeTypeOptions.find((data) => data.id === prevStatus)
          );
        }
      }
      if (skillLevelOptions?.length > 0) {
        if (!skillLevel?.id) {
          setSkillLevel((prevStatus) =>
            skillLevelOptions.find((data) => data.id === prevStatus)
          );
        }
      }
      if (qualificationOptions?.length > 0) {
        if (!qualification?.id) {
          setQualification((prevStatus) =>
            qualificationOptions.find((data) => data.id === prevStatus)
          );
        }
      }
      if (selectedWorkGroups?.length > 0 && workGroupOptions?.length > 0) {
        if (workGroups.length === 0) {
          const filteredWorkGroups = workGroupOptions.filter((option) => {
            return selectedWorkGroups?.includes(option.id);
          });
          setWorkGroups(filteredWorkGroups);
          setSelectedWorkGroups([]);
        }
      }
    }
  }, [
    employeeTypeOptions,
    skillLevelOptions,
    qualificationOptions,
    isEdit,
    workGroupOptions,
    selectedWorkGroups,
  ]);


  const fetchEmployeeOptions = async () => {

    try {
      const employeeResponse = await axios.get(`${ifacSecurityURL}/api/GraphUserRegistration/GetSecuserregisterByFacilityid/${facilityId}/${companyId}`, config)

      setEmployeeOptions(employeeResponse.data.map((emp) => {
        return {
          label: `${emp.employeeCode} - ${emp.firstName}`,
          value: emp.employeeCode,
          ...emp
        }
      }))
    } catch (error) {
      console.error("Error fetching options:", error);
    }

  }

  const fetchOptions = async (selectedServices = []) => {
    try {
      const [
        skillLevelResponse,
        qualificationResponse,
        workGroupBems,
        workGroupFems,
        employeeTypeResponse,
      ] = await Promise.all([
        axios.get(`${MasterGraph}/api/masemployeeskilllevels`, config),
        axios.get(`${MasterGraph}/api/masemployeequalifications`, config),
        axios.get(`${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`, config),
        axios.get(`${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=100`, config),
        axios.get(`${MasterGraph}/api/masemployeetypes`, config),
      ]);

      const workGroupResponse = [
        ...workGroupFems.data.map((data) => {
          return {
            label: `${data.wgcode}-${data.wgdesc}`,
            value: `${data.wgcode}-${data.wgdesc}`,
            id: data.id,
            service: "FEMS",
          };
        }),
        ...workGroupBems.data.map((data) => {
          return {
            label: `${data.wgcode} ${data.wgdesc}`,
            value: `${data.wgcode} ${data.wgdesc}`,
            id: data.id,
            service: "BEMS",
          };
        }),
      ];
      setResponseWorkgroupArray(workGroupResponse);
      if (isEdit) {
        setWorkGroupOptions(
          workGroupResponse.filter((option) =>
            selectedServices.includes(option.service)
          )
        );
      }

      setQualificationOptions(
        qualificationResponse.data
          .map((data) => ({
            label: data.qualificationDesc,
            value: data.qualificationDesc,
            id: data.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      );

      setSkillLevelOptions(
        skillLevelResponse.data
          .map((data) => ({
            label: data.employeeSkill,
            value: data.employeeSkill,
            id: data.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      );
      setEmployeeTypeOptions(
        employeeTypeResponse.data
          .map((data) => ({
            label: data.employeeType,
            value: data.employeeType,
            id: data.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      );
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  useEffect(() => {
    if (location.state) {
      const { isEditMode } = location.state;
      setIsEdit(isEditMode);
    }
  }, [location.state]);

  useEffect(() => {
    setWorkGroupOptions(
      responseWorkgroupArray.filter((option) =>
        selectedServices.includes(option.service)
      )
    );
  }, [selectedServices, isEdit, workGroups]);


  const handleEmployeeIdChange = (newvalue) => {
    if (newvalue.label == "") {
      setDeafault();
    }
    else {
      setEmployeeId({ ...newvalue, label: newvalue.value });
      setEmployeeName(newvalue.firstName);
      setBaseLocationCode(newvalue.facilityCode)
      setBaseLocationDesc(newvalue.facilityName)
      setRoleName(newvalue.roleName)
      setRoleDescription(newvalue.roleDesc)
      setErrors((prev) => ({ ...prev, employeeId: false }));
      setErrorMessages((prev) => ({ ...prev, employeeId: "" }));

    }
  };

  const handleDescClear = () => {
    if (isChanged) {
      setOpenDialog(true);
      setContentDialog(dialogContent.modified);
      setIsNavigate(false)
    } else {
      setDeafault()
    }
  };

  const handleDesignationChange = (newvalue) => {
    setDesignation(newvalue);

    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, designation: false }));
      setErrorMessages((prev) => ({ ...prev, designation: "" }));
    }
    if (utilities.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, designation: false }));
      setErrorMessages((prev) => ({ ...prev, designation: "" }));
    } else if (!utilities.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, designation: true }));
      setErrorMessages((prev) => ({
        ...prev,
        designation: validations.textfield,
      }));
    }
  };
  const handleWorkGroupsChange = (newvalue) => {
    setWorkGroups(newvalue);
    if (newvalue.length > 0) {
      setErrors((prev) => ({ ...prev, workGroups: false }));
      setErrorMessages((prev) => ({
        ...prev,
        workGroups: "",
      }));
    }
  };
  const handleEffectiveFromChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, effectiveFrom: false }));
      setErrorMessages((prev) => ({ ...prev, effectiveFrom: "" }));
    }
    setEffectiveFrom(newvalue);
  };
  const handleSkillLevelChange = (newvalue) => {
    setIsChanged(true);
    setSkillLevel(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, skillLevel: false }));
      setErrorMessages((prev) => ({ ...prev, skillLevel: "" }));
    }
  };
  const handleQualificationChange = (newvalue) => {
    setIsChanged(true);
    setQualification(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, qualification: false }));
      setErrorMessages((prev) => ({ ...prev, qualification: "" }));
    }
  };
  const handleHourlyRateChange = (newvalue) => {
    setIsChanged(true);
    setHourlyRate(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, hourlyRate: false }));
      setErrorMessages((prev) => ({ ...prev, hourlyRate: "" }));
    }
    if (utilities.validatePrice(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, hourlyRate: false }));
      setErrorMessages((prev) => ({ ...prev, hourlyRate: "" }));
    } else if (!utilities.validatePrice(newvalue)) {
      setErrors((prev) => ({ ...prev, hourlyRate: true }));
      setErrorMessages((prev) => ({
        ...prev,
        hourlyRate: validations.price,
      }));
    }
  };


  const handleEmployeTypeChange = (newvalue) => {
    setIsChanged(true);
    setEmployeeType(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, employeeType: false }));
      setErrorMessages((prev) => ({ ...prev, employeeType: "" }));
    }
  };

  const handleServiceChange = (event) => {
    setIsChanged(true);
    const { value, checked } = event.target;
    if (checked) {
      setErrors((prev) => ({ ...prev, services: false }));
      setErrorMessages((prev) => ({ ...prev, services: "" }));
    }
    setSelectedServices((prev) =>
      checked ? [...prev, value] : prev.filter((service) => service !== value)
    );
  };

  const handleSubmit = () => {
    const requiredFields = [
      {
        field: "employeeId",
        value: employeeId,
        message: staff.employeeid.required,
        lookup: true
      },
      {
        field: "designation",
        value: designation,
        message: staff.designation.required,
      },
      {
        field: "workGroups",
        value: workGroups,
        message: staff.workgroup.required,
      },
      {
        field: "service",
        value: selectedServices,
        message: staff.service.required,
      },
      {
        field: "effectiveFrom",
        value: effectiveFrom,
        message: staff.effectivefrom.required,
      },
      {
        field: "skillLevel",
        value: skillLevel,
        message: staff.skilllevel.required,
      },
      {
        field: "employeeType",
        value: employeeType,
        message: staff.employeetype.required,
      },
    ];
    let isValid = true;
    requiredFields.forEach((field) => {
      if (!field.value) {
        isValid = false;
        setErrors((prev) => ({ ...prev, [field.field]: true }));
        setErrorMessages((prev) => ({ ...prev, [field.field]: field.message }));
      }
      if (!field.value.label && field.lookup) {
        isValid = false;
        setErrors((prev) => ({ ...prev, [field.field]: true }));
        setErrorMessages((prev) => ({ ...prev, [field.field]: field.message }));
      }
    });

    if (selectedServices.length === 0) {
      isValid = false;
      setErrors((prev) => ({ ...prev, services: true }));
      setErrorMessages((prev) => ({
        ...prev,
        services: staff.service.required,
      }));
    }
    if (workGroups.length === 0) {
      isValid = false;
      setErrors((prev) => ({ ...prev, workGroups: true }));
      setErrorMessages((prev) => ({
        ...prev,
        workGroups: staff.workgroup.required,
      }));
    }
    // Check if all error messages are empty
    if (!Object.values(errorMessages).every((value) => value === "")) {
      isValid = false;
    }
    // If form is valid, proceed with saving
    if (isValid) {
      handleSave();
    }
  };

  const handleSave = async () => {
    const userId = getuserId();
    const postData = {
      imagepath: imagepath,
      employeeCode: isEdit ? employeeId?.empCode : employeeId?.employeeCode,
      facilityId: isEdit ? employeeId?.locationId : employeeId?.facilityId,
      masemployeetype: {
        id: employeeType.id,
        employeeType: employeeType.value,
      },
      employeeName: employeeName,
      isactive: true,
      effectiveFrom: utilities.formatDate({
        dateString: effectiveFrom,
        format: "YYYY-MM-DD",
        includeTime: true,
      }),
      masemployeeskilllevel: {
        id: skillLevel.id,
        employeeSkill: skillLevel.value,
      },
      hourlyRate: hourlyRate,
      empservice: selectedServices.join(", "),
      baseLocationId: isEdit ? employeeId?.locationId : employeeId?.facilityId,
      designation: designation,
      masemployeequalification: qualification
        ? {
          id: qualification.id,
          qualificationDesc: qualification.value,
        }
        : null,
      modifiedBy: userId,
      workgroup: workGroups.map((workgroup) => workgroup.id).join(", "),
      isVisible: true,
      roleid: employeeId?.roleId,
      userId: isEdit ? employeeId?.userId : employeeId?.id
    };
    if (isEdit) {
      postData["id"] = id;
    } else {
      postData["createdby"] = userId;
    }

    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const endpoint = isEdit
        ? `${MasterGraph}/api/masemployeedetails/${id}`
        : `${MasterGraph}/api/masemployeedetails`;

      let result = await axios({
        method: isEdit ? "put" : "post",
        url: endpoint,
        data: postData,
        headers: config.headers,
      });
      if (result.status === 201) {
        setContentDialog(dialogContent.saved);
        setIsChanged(false);
        setOpenValidationDialog(true);
        setEnableSubmit(false);
        if (childRef.current) {
          childRef.current.handleSubmitClick(result.data);
        }
      }
      if (result.status === 200) {
        setContentDialog(dialogContent.updated);
        setIsChanged(false);
        setOpenValidationDialog(true);
        if (childRef.current) {
          childRef.current.handleSubmitClick(postData);
        }
      }
    } catch (error) {
      console.log(error);
      if (error.response.status === 400) {
        setOpenValidationDialog(true);
        setContentDialog(error.response.data.detail || validations.default);
      }
    }
  };
  const fileInputRef = useRef(null);

  const formData = {
    employeeId,
    employeeName,
    designation,
    workGroups,
    selectedServices,
    skillLevel,
    selectedFiles,
    baseLocationCode,
    roleName,
    employeeType,
    previewUrl,
    qualification,
    hourlyRate,
  };
  const areAllEmpty = () => {
    if (!isEdit) {
      for (const key in formData) {
        if (Array.isArray(formData[key])) {
          if (formData[key].length !== 0) {
            return false;
          }
        } else if (formData[key]) {
          return false;
        }
      }
      return true;
    }
  };

  const handleCancel = () => {
    if (!isChanged || areAllEmpty()) {
      navigate("/staffdetails");
    }
    setOpenDialog(true);
    setContentDialog(dialogContent.modified);
  };

  const handleDialogConfirm = () => {
    setOpenValidationDialog(false);
    setOpenDialog(false);
    if (isChanged && !openValidationDialog && !isAddNew) {
      if (!isNavigate) {
        setOpenDialog(false);
        setIsNavigate(true)
        setDeafault()
      } else {
        navigate("/staffdetails");
      }
    }
    if (isAddNew) {
      setDeafault();
    }
  };

  const handleAddNew = () => {
    if (isChanged) {
      setIsAddNew(true);
      setOpenDialog(true);
      setContentDialog(dialogContent.modified);
    } else {
      setDeafault();
    }
  };

  const handleDialogClose = () => {
    if (isChanged) {
      setOpenDialog(false);
    }
    if (isAddNew) {
      setIsAddNew(false);
    }
  };

  useEffect(() => {
    if (selectedFiles.length > 0) {
      setIsChanged(true);
    }
  }, [selectedFiles]);

  const setDeafault = () => {
    setClearField(true)
    setEnableSubmit(true);
    setEmployeeId("");
    setEmployeeName("");
    setDesignation("");
    setWorkGroups([]);
    setSelectedServices([]);
    setHourlyRate("");
    setSkillLevel("");
    setQualification("");
    setBaseLocationCode("");
    setBaseLocationDesc("");
    setRoleName("");
    setRoleDescription("");
    setEmployeeType("");
    setEffectiveFrom(currentDate);
    setErrorMessages({});
    setErrors({});
    setFRowData([]);
    setPreviewUrl("");
    setIsAddNew(false);
    setIsChanged(false);
  };
  const allowedFileExtensions = ["jpeg", "jpg", "png"];

  const handleFileChange = async (event) => {

    const file = event.target.files[0];
    if (!file) return;

    const fileName = file.name;
    const fileExtension = fileName.split(".").pop().toLowerCase();

    if (!allowedFileExtensions.includes(fileExtension)) {
      setOpenValidationDialog(true);
      setContentDialog("Only JPEG, JPG, PNG files are allowed.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setOpenValidationDialog(true);
      setContentDialog("File size exceeds 5 MB. Please select smaller files.");
      return;
    }

    try {
      setIsLoading(true)
      // Step 1: Compress the image
      const compressedFile = await compressImage(file, 15); // Target ~15 KB

      // Step 2: Convert compressed image to Base64
      const base64 = await fileToBase64(compressedFile);
      setImagePath(base64);

      // Step 3: Create a preview URL
      const url = URL.createObjectURL(compressedFile);
      setPreviewUrl(url);
      setIsChanged(true);
    } catch (error) {
      console.error("Error during image processing:", error);
      setOpenValidationDialog(true);
      setContentDialog("Failed to process the image. Please try again.");
    }
    finally {
      setIsLoading(false)
    }
  };

  const compressImage = async (file, targetSizeKB) => {
    try {
      // Fixed options for consistent, faster performance
      const options = {
        maxSizeMB: targetSizeKB / 1024, // Compress to target size
        maxWidthOrHeight: 800, // Resize to 800px (optimized for speed)
        useWebWorker: true, // Leverage Web Workers for faster compression
        initialQuality: 0.8, // Start compression with lower quality for faster results
      };

      const compressedFile = await imageCompression(file, options);

      return compressedFile;
    } catch (error) {
      console.error("Compression failed:", error);
      throw error;
    }
  };


  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(new Error("Failed to convert file to Base64."));
      reader.readAsDataURL(file);
    });
  };

  const handleEditClick = () => {
    fileInputRef.current.click();
  };

  return (
    <>
      <PageLoader open={isLoading} text={'Uploading Profile'} />
      <PageTitle
        isEdit={isEdit}
        editTitle={"Edit Staff Details"}
        title={"Register New Staff"}
      />
      <DefaultCard>
        <SectionTitle title={"Staff Details"} />
        <Stack direction={"row"} justifyItems={"center"} alignItems={"center"}>
          <Stack mb={2} width={120} position={"relative"}>
            <Avatar sx={{ width: 100, height: 100 }} alt="" src={previewUrl} />
            <Button
              variant="contained"
              onClick={handleEditClick}
              sx={profileEditStyle}
            >
              <ModeEditOutlineRoundedIcon fontSize="small" />
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => handleFileChange(e)}
              />
            </Button>
          </Stack>
          <Stack verticalAlign={"center"}>
            <Typography variant="subtitle1">Profile Picture</Typography>
            <Typography variant="labelSm">
              Support Only JPEG, JPG, PNG under 5MB
            </Typography>
          </Stack>
        </Stack>
        <Grid container spacing={4}>
          <Grid item xs={6} md={4}>
            <CustomTextFieldWithSearch
              label="Staff ID"
              value={employeeId}
              onChange={handleEmployeeIdChange}
              isMandatoryField={true}
              disabled={isEdit}
              maxLength={20}
              error={errors.employeeId}
              helperText={errorMessages.employeeId}
              options={employeeOptions}
              onClear={handleDescClear}
              clearField={clearField}
              setClearField={setClearField}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <CustomTextField
              label="Staff Name"
              value={employeeName}
              disabled={true}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <FormControl fullWidth error={true}>
              <Box>
                <Typography variant="labelSm">Service</Typography>
                <Typography component={"span"} color={"error"}>
                  *
                </Typography>
              </Box>
              {errors.services && (
                <FormHelperText sx={{ marginLeft: "0px" }}>
                  {errorMessages.services}
                </FormHelperText>
              )}
              <FormGroup row>
                {serviceOptions.map((service) => (
                  <FormControlLabel
                    key={service.value}
                    control={
                      <Checkbox
                        error={true}
                        checked={selectedServices?.includes(service.value)}
                        onChange={handleServiceChange}
                        value={service.value}
                      />
                    }
                    label={service.label}
                  />
                ))}
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs={6} md={4}>
            <CustomTextField
              label={"Base Location - Code"}
              value={baseLocationCode}
              disabled={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomTextField
              label={"Base Location - Description"}
              value={baseLocationDesc}
              disabled={true}
            />
          </Grid>






          <Grid item xs={6} md={4}>
            <CustomMultiSelect
              label="Work Group"
              values={workGroups}
              options={workGroupOptions}
              onChange={handleWorkGroupsChange}
              isMandatoryField={true}
              error={errors.workGroups}
              helperText={errorMessages.workGroups}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <CustomTextField
              label={"Role Name"}
              value={roleName}
              disabled={true}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomTextField
              label={"Role Description"}
              value={roleDescription}
              disabled={true}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <CustomTextField
              label="Designation"
              value={designation}
              onChange={handleDesignationChange}
              isMandatoryField={true}
              maxLength={60}
              error={errors.designation}
              helperText={errorMessages.designation}
            />
          </Grid>


          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Staff Type"
              onChange={handleEmployeTypeChange}
              value={employeeType}
              options={employeeTypeOptions}
              isMandatoryField={true}
              error={errors.employeeType}
              helperText={errorMessages.employeeType}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <CustomDatePicker
              label="Effective From"
              isMandatoryField={true}
              value={effectiveFrom}
              id="effective-from"
              onDateChange={handleEffectiveFromChange}
              error={errors.effectiveFrom}
              helperText={errorMessages.effectiveFrom}
            />
          </Grid>


          <Grid item xs={6} md={4}>
            <CustomTextField
              label="Hourly Rate(RM)"
              value={hourlyRate}
              onChange={handleHourlyRateChange}
              error={errors.hourlyRate}
              helperText={errorMessages.hourlyRate}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Skill Level"
              onChange={handleSkillLevelChange}
              value={skillLevel}
              options={skillLevelOptions}
              isMandatoryField={true}
              error={errors.skillLevel}
              helperText={errorMessages.skillLevel}
            />
          </Grid>


          <Grid item xs={6} md={4}>
            <CustomSelectInput
              label="Qualification"
              onChange={handleQualificationChange}
              value={qualification}
              options={qualificationOptions}
              error={errors.qualification}
              helperText={errorMessages.qualification}
            />
          </Grid>
        </Grid>
      </DefaultCard>

      <FileHandling
        ref={childRef}
        isEdit={isEdit}
        id={id}
        rowData={fRowData}
        setRowData={setFRowData}
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
      />
      <ActionButtons
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        handleAddNew={handleAddNew}
        enableSubmit={enableSubmit}
        isEdit={isEdit}
        saveLabel="Save"
      />
      <CustomDialog
        cancelBtn={"No"}
        open={openDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Yes"}
      />
      <CustomDialog
        open={openValidationDialog}
        onConfirm={handleDialogConfirm}
        content={contentDialog}
        onClose={handleDialogClose}
        confirmBtn={"Ok"}
      />
    </>
  );
}

export default StaffRegister;
